export class ClosureConstants {
  public static pending_options: any = {
    pending_payment: "Saldo a favor con pago pendiente",
    anomaly: "Anomalía en caso",
    deposit_not_found: "Datos de pago no válidos",
  };

  public static closure_translation: any = {
    accident: "Siniestro",
    decease: "Fallecimiento",
    dation: "Dación",
    termination: "Terminación",
    cancellation: "Cancelación",
  };

  public static types_translation: any = {
    tenure: "Tenencia",
    fines: "Multas",
    low_plates: "Baja de placas",
    outstanding_balance: "Saldo insoluto",
    actual_month_rent: "Renta del mes actual",
    accumulated_debt: "Renta adeudada",
    interest_ordinary_car: "Intereses ordinarios",
    gps_uninstall: "Desinstalación del gps",
    recovery_cost: "Costo de recuperación",
    change_owner: "Cambio de propietario",
    insurance_remainder: "Remanente de seguro",
    penalty: "Penalización",
    additional_vehicle_charge: "Trámite vehicular adicional",
    mechanical_repair: "Reparación mecánica",
    appraisal: "Avalúo",
    pension: "Pensión",
    intermediary_for_sale: "Intermediario por venta",
    residual_value: "Valor residual",
    pending_rents: "Rentas",
    refund_disbursement: "Devolucion de desembolso",
    refund_commissions: "Devolucion de comisiones pagadas",
  };

  public static charge_types = {
    accident: ["tenure", "fines", "low_plates", "penalty"],
    decease: ["tenure", "fines", "low_plates", "panalty"],
    dation: [
      "tenure",
      "fines",
      "low_plates",
      "recovery_cost",
      "penalty",
      "mechanical_repair",
      "appraisal",
      "pension",
      "intermediary_for_sale",
    ],
    termination: ["tenure", "fines", "low_plates", "change_owner", "additional_vehicle_charge", "residual_value"],
    cancellation: ["tenure", "fines", "low_plates", "change_owner", "refund_disbursement", "refund_commissions"],
  };

  public static proofs_in_review = {
    accident: [
      { key: "accident_proof", document: null, document_name: "", document_tittle: "Acta de siniestro", active: true },
      {
        key: "unearned_premium",
        document: null,
        document_name: "",
        document_tittle: "Prima no devengada",
        active: true,
      },
      { key: "low_plates", document: null, document_name: "", document_tittle: "Baja de placas", active: true },
      {
        key: "gps_uninstall",
        document: null,
        document_name: "",
        document_tittle: "Desinstalación de GPS",
        active: true,
      },
    ],
    dation: [
      {
        key: "digital_checklist",
        document: null,
        document_name: "",
        document_tittle: "Checklist digital",
        active: true,
      },
      {
        key: "autometrica_amount",
        document: null,
        document_name: "",
        document_tittle: "Valor autométrica",
        active: true,
      },
      {
        key: "unearned_premium",
        document: null,
        document_name: "",
        document_tittle: "Prima no devengada",
        active: true,
      },
      { key: "low_plates", document: null, document_name: "", document_tittle: "Baja de placas", active: true },
      {
        key: "gps_uninstall",
        document: null,
        document_name: "",
        document_tittle: "Desinstalación de GPS",
        active: true,
      },
    ],
    decease: [
      {
        key: "decease_proof",
        document: null,
        document_name: "",
        document_tittle: "Comprobante de defunción",
        active: true,
      },
      {
        key: "unearned_premium",
        document: null,
        document_name: "",
        document_tittle: "Prima no devengada",
        active: true,
      },
      { key: "low_plates", document: null, document_name: "", document_tittle: "Baja de placas", active: true },
      {
        key: "gps_uninstall",
        document: null,
        document_name: "",
        document_tittle: "Desinstalación de GPS",
        active: true,
      },
    ],
    termination: [
      {
        key: "gps_uninstall",
        document: null,
        document_name: "",
        document_tittle: "Desinstalación de GPS",
        active: true,
      },
      {
        key: "unearned_premium",
        document: null,
        document_name: "",
        document_tittle: "Prima no devengada",
        active: true,
      },
    ],
    cancellation: [
      {
        key: "gps_uninstall",
        document: null,
        document_name: "",
        document_tittle: "Desinstalación de GPS",
        active: true,
      },
      {
        key: "unearned_premium",
        document: null,
        document_name: "",
        document_tittle: "Prima no devengada",
        active: true,
      },
    ],
  };

  public static checklist = {
    accident: [
      { key: "low_plates", value: false, name: "Baja de placas", document: null, document_name: "" },
      { key: "gps_uninstall", value: false, name: "Desinstalación de GPS", document: null, document_name: "" },
      {
        key: "compensated_payment",
        value: false,
        name: "Pago indemnización/No indeminzado",
        document: null,
        document_name: "",
      },
    ],
    dation: [
      { key: "low_plates", value: false, name: "Baja de placas", document: null, document_name: "" },
      { key: "gps_uninstall", value: false, name: "Desinstalación de GPS", document: null, document_name: "" },
      { key: "insurance_cancelation", value: false, name: "Cancelación de seguro", document: null, document_name: "" },
    ],
    decease: [
      { key: "low_plates", value: false, name: "Baja de placas", document: null, document_name: "" },
      { key: "gps_uninstall", value: false, name: "Desinstalación de GPS", document: null, document_name: "" },
      {
        key: "compensated_payment",
        value: false,
        name: "Pago indemnización/No indeminzado",
        document: null,
        document_name: "",
      },
    ],
    termination: [
      {
        key: "official_identification",
        value: false,
        name: "Identificación oficial",
        document: null,
        document_name: "",
      },
      { key: "circulation_card", value: false, name: "Tarjeta de circulación", document: null, document_name: "" },
      { key: "address_proof", value: false, name: "Comprobante de domicilio", document: null, document_name: "" },
    ],
    natural_termination_pf: [
      {
        key: "official_identification",
        value: false,
        name: "Identificación oficial",
        document: null,
        document_name: "",
      },
      { key: "circulation_card", value: false, name: "Tarjeta de circulación", document: null, document_name: "" },
      { key: "address_proof", value: false, name: "Comprobante de domicilio", document: null, document_name: "" },
    ],
    natural_termination_pm: [
      {
        key: "official_identification",
        value: false,
        name: "Identificación oficial",
        document: null,
        document_name: "",
      },
      { key: "power_attorney", value: false, name: "Poder notarial", document: null, document_name: "" },
      { key: "constitutive_act", value: false, name: "Acta constitutiva", document: null, document_name: "" },
      { key: "address_proof", value: false, name: "Comprobante de domicilio", document: null, document_name: "" },
    ],
  };

  public static status_options = {
    accident: {
      created: { label: "Nuevo", color: "lightish-blue fc-white", action: "Gestionar" },
      in_review: { label: "En revisión", color: "bg-warm-blue fc-white", action: "Gestionar" },
      compensated: { label: "Indemnizado", color: "lightish-green fc-white", action: "Gestionar" },
      no_compensation: { label: "No indenmnizada", color: "bg-marine fc-white", action: "Gestionar" },
      closed: { label: "Cerrado", color: "bg-secondary fc-black", action: "Gestionar" },
      incident: { label: "Incidencia", color: "bg-yellow-corn fc-black", action: "Gestionar" },
      cancelled: { label: "Cancelado", color: "bg-slate-grey fc-white", action: "Ver detalle" },
      requested: { label: "Cierre solicitado", color: "lightish-green fc-white", action: "Gestionar" },
      pending: { label: "Pendiente", color: "bg-warning fc-white", action: "Ver detalle" },
    },
    dation: {
      incident: { label: "Incidencia", color: "bg-yellow-corn fc-black", action: "Gestionar" },
      cancelled: { label: "Cancelado", color: "bg-slate-grey fc-white", action: "Ver detalle" },
      in_review: { label: "En revisión", color: "bg-warm-blue fc-white", action: "Gestionar" },
      created: { label: "Nuevo", color: "lightish-blue fc-white", action: "Gestionar" },
      in_agency: { label: "En agencia", color: "bg-marine fc-white", action: "Gestionar" },
      in_marketplace: { label: "En marketplace", color: "bg-marine fc-white", action: "Gestionar" },
      in_disassembly: { label: "Desmontaje", color: "bg-yellow-corn fc-white", action: "Gestionar" },
      sold: { label: "Vendido", color: "bg-secondary fc-white", action: "Gestionar" },
      closed: { label: "Cerrado", color: "bg-secondary fc-white", action: "Gestionar" },
      requested: { label: "Cierre solicitado", color: "lightish-green fc-white", action: "Gestionar" },
      pending: { label: "Pendiente", color: "bg-warning fc-white", action: "Ver detalle" },
    },
    decease: {
      created: { label: "Nuevo", color: "lightish-blue fc-white", action: "Gestionar" },
      in_review: { label: "En revisión", color: "bg-warm-blue fc-white", action: "Gestionar" },
      compensated: { label: "Indemnizado", color: "lightish-green fc-white", action: "Gestionar" },
      no_compensation: { label: "No indenmnizada", color: "bg-marine fc-white", action: "Gestionar" },
      closed: { label: "Cerrado", color: "bg-secondary fc-black", action: "Gestionar" },
      incident: { label: "Incidencia", color: "bg-yellow-corn fc-black", action: "Gestionar" },
      cancelled: { label: "Cancelado", color: "bg-slate-grey fc-white", action: "Ver detalle" },
      requested: { label: "Cierre solicitado", color: "lightish-green fc-white", action: "Gestionar" },
      pending: { label: "Pendiente", color: "bg-warning fc-white", action: "Ver detalle" },
    },
    termination: {
      created: { label: "Nuevo", color: "lightish-blue fc-white", action: "Gestionar" },
      notified: { label: "Notificado", color: "bg-warm-blue fc-white", action: "Gestionar" },
      payment_completed: { label: "Pago completo", color: "lightish-green fc-white", action: "Gestionar" },
      no_compensated: { label: "No indenmnizada", color: "bg-marine fc-white", action: "Gestionar" },
      closed: { label: "Cerrado", color: "bg-secondary fc-black", action: "Gestionar" },
      incident: { label: "Incidencia", color: "bg-yellow-corn fc-black", action: "Gestionar" },
      cancelled: { label: "Cancelado", color: "bg-slate-grey fc-white", action: "Ver detalle" },
      requested: { label: "Cierre solicitado", color: "lightish-green fc-white", action: "Gestionar" },
      pending: { label: "Pendiente", color: "bg-warning fc-white", action: "Ver detalle" },
    },
    cancellation: {
      created: { label: "Nuevo", color: "lightish-blue fc-white", action: "Gestionar" },
      notified: { label: "Notificado", color: "bg-warm-blue fc-white", action: "Gestionar" },
      payment_completed: { label: "Pago completo", color: "lightish-green fc-white", action: "Gestionar" },
      no_compensated: { label: "No indenmnizada", color: "bg-marine fc-white", action: "Gestionar" },
      closed: { label: "Cerrado", color: "bg-secondary fc-black", action: "Gestionar" },
      incident: { label: "Incidencia", color: "bg-yellow-corn fc-black", action: "Gestionar" },
      cancelled: { label: "Cancelado", color: "bg-slate-grey fc-white", action: "Ver detalle" },
      requested: { label: "Cierre solicitado", color: "lightish-green fc-white", action: "Gestionar" },
      pending: { label: "Pendiente", color: "bg-warning fc-white", action: "Ver detalle" },
    },
  };

  public static accident_type: any = {
    car_theft: "Robo",
    total_loss: "Pérdida total",
  };

  public static status_closed: any = {
    refund: "Cerrar y devolver al cliente",
    retain: "Cerrar y retener al cliente",
    collection: "Cerrado en cobranza por",
  };

  public static payment_banks: string[] = ["bbva", "cibanco", "stp"];

  public static payment_banks_translation: any = {
    bbva: "BBVA",
    cibanco: "CI BANCO",
    stp: "STP",
  };

  public static columns_options = {
    accident: ["client_name", "lead", "vin", "accident_number", "accident_date", "update_date", "status", "action"],
    dation: ["client_name", "vin", "lead", "admission_date", "update_date", "status", "action"],
    decease: ["client_name", "lead", "vin", "accident_number", "accident_date", "update_date", "status", "action"],
    termination: [
      "selection",
      "client_name",
      "lead",
      "vin",
      "product",
      "last_payment_date",
      "update_date",
      "status",
      "action",
    ],
    cancellation: [
      "selection",
      "client_name",
      "lead",
      "vin",
      "product",
      "last_payment_date",
      "update_date",
      "status",
      "action",
    ],
  };

  public static closure_tabs = [
    { closure_type: "termination", translation: "Terminación" },
    { closure_type: "accident", translation: "Siniestro" },
    { closure_type: "decease", translation: "Fallecimiento" },
    { closure_type: "dation", translation: "Dación" },
    { closure_type: "cancellation", translation: "Cancelación" },
  ];

  public static date_title_options = {
    accident: "Fecha de siniestro",
    dation: "Fecha de recuperación",
    decease: "Fecha de siniestro",
    termination: "Fecha de última mensualidad",
    cancellation: "Fecha de última mensualidad",
  };

  public static add_title_options = {
    accident: "Agregar siniestro",
    decease: "Agregar fallecimiento",
    termination: "Agregar terminación",
    cancellation: "Agregar cancelación",
  };
}
